import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Condition } from 'Component/others';
import { useAppSystem } from 'Store/app';
import ScrollToTop from 'View/host-stock-promo/component/scroll-to-top';
import Filter from 'View/host-stock-promo/section/filter';
import Head from 'View/host-stock-promo/section/head';
import Promo from 'View/host-stock-promo/section/promo';
import HostPromoDetail from 'View/host-stock-promo/section/promo-detail';
import Stock from 'View/host-stock-promo/section/stock';
import HostStockDetail from 'View/host-stock-promo/section/stock-detail';
import Tab from 'View/host-stock-promo/section/tab';
import HostStockPromoProvider from 'View/host-stock-promo/state';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import styles from './styles.module.css';

const HostStockPromo = () => {
  const location = useLocation();
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isDetailFromNavigation, setIsDetailFromNavigation] = useState(false);

  const { state, updateState, filterState } = useHostStockPromoState();
  const { onChangeAppSystem } = useAppSystem();

  const isDetailView = state?.selectedDetailStock || state?.selectedDetailPromo;

  useEffect(() => {
    if (location?.state?.selectedDetailPromo) {
      setIsDetailFromNavigation(true);
      updateState({ selectedDetailPromo: location.state.selectedDetailPromo });
      onChangeAppSystem({ isHideMobileNavBar: true });
    }
    if (location?.state?.selectedDetailStock) {
      setIsDetailFromNavigation(true);
      updateState({ selectedDetailStock: location.state.selectedDetailStock });
      onChangeAppSystem({ isHideMobileNavBar: true });
    }
  }, [location?.state, updateState, onChangeAppSystem]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [
    state?.selectedTab,
    state?.selectedDetailStock,
    state?.selectedDetailPromo,
    filterState?.brandId,
    filterState?.stockStatus,
    filterState?.promoStatus,
    filterState?.store,
    filterState?.search,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      updateState({ showTopBar: currentScrollY < lastScrollY || currentScrollY < 42, showScrollToTop: currentScrollY > 42 });
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, updateState]);

  return (
    <Box className={styles['host-stock-promo__container']}>
      <Condition statement={!isDetailView}>
        <Tab />
        <Filter />
        <Condition statement={state?.selectedTab === 'stok'} children={<Stock />} />
        <Condition statement={state?.selectedTab === 'promo'} children={<Promo />} />
      </Condition>

      <Condition statement={isDetailView}>
        <Head isDetailFromNavigation={isDetailFromNavigation} />
        <Condition statement={state?.selectedDetailStock} children={<HostStockDetail />} />
        <Condition statement={state?.selectedDetailPromo} children={<HostPromoDetail />} />
      </Condition>

      <ScrollToTop />
    </Box>
  );
};

const HostStockPromoContainer = () => <HostStockPromoProvider children={<HostStockPromo />} />;

export default HostStockPromoContainer;
